export function getDarkToken(zoomUI) {
    const { semantic, shadow, typography, zIndex } = zoomUI;
    return {
        zIndex: zIndex.Tooltip,
        fontFamily: typography.fontFamily,
        fontSize: typography.fontSize.subtitle,
        fontWeight: typography.fontWeight.subtitle,
        lineHeight: typography.lineHeight.subtitle,
        borderColor: semantic.dark.border.subtle.neutral,
        backgroundColor: semantic.dark.fill.default,
        boxShadow: shadow.sm,
        textColor: semantic.dark.text.stronger.neutral,
    };
}
